import { DataInterop } from '@silvertours/front-shared';

type AuthorProps = {
  name: string;
  text: string;
  prefix: string;
  role: string;
  url?: string;
  worksFor?: string;
  knowsAbout?: string[];
  type?: string;
};

export const AuthorData = (author: AuthorProps) => {
  const {
    name,
    role,
    url,
    text,
    worksFor,
    knowsAbout,
    type = 'Person',
  } = author;

  const authorData = {
    '@type': type,
    name,
    jobTitle: role,
    description: text,
    ...(url && { url }),
    ...(worksFor && {
      worksFor: {
        '@type': 'Organization',
        name: worksFor,
        url: `https://www.${worksFor}`,
      },
    }),
    ...(knowsAbout && knowsAbout.length > 0 && { knowsAbout }),
  };

  return (
    <DataInterop.StructuredData data={authorData} type={type} includeContext />
  );
};
